/**
* Created by vouill on 2019-02-04.
*/

<template>
  <div>
    <contenful-apis
      url="spaces/uhuxxitrg1zr/entries"
      :params="{ content_type: 'author', include: 3, order:'fields.lastname' }"
      :key-path="['authors']"
    />
    <vuex-api-hoc
      :key-path="['websiteMeta']"
    >
      <template slot="success"><Title /></template>
    </vuex-api-hoc>
    <vuex-api-hoc
      :key-path="['authors']"
    >
      <template slot="success"><AuthorContainer/></template>
    </vuex-api-hoc>
  </div>
</template>

<script>
import AuthorContainer from "./AuthorContainer";
import Title from "./Title";
export default {
  name: "Authors",
  props: {},
  components: { Title, AuthorContainer },
  data() {
    return {};
  }
};
</script>
